﻿'use strict';

/**
* Factory for handling session management
* @memberOf components.sessionModule
* @namespace sessionManagementFactory
*/

sessionManagementFactory.$inject = ['$rootScope', '$timeout', '$q', 'authenticationFactory', 'data_project_constants'];

function sessionManagementFactory($rootScope, $timeout, $q, authenticationFactory, data_project_constants) {

    //constants for the subscription names
    var SESSION_START_SUB = data_project_constants.session_events.session_start;
    var SESSION_END_SUB = data_project_constants.session_events.session_end;
    var SESSION_WARNING_SUB = data_project_constants.session_events.session_warning;

    //constant for time length of session
    var TIME_END_LENGTH = data_project_constants.session_event_times.session_end;
    var TIME_WARNING_LENGTH = data_project_constants.session_event_times.session_warn;

    //timing based variables
    var timeStart;
    var endTime;
    var warningTime;

    //is the session currently started
    var sessionStarted = false;

    /**
    * Allow callers to use different events
    * @method sessionManagementEvents
    * @returns {SessionManagementSubscriptionType}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionManagementEvents() {
        return {
            SessionStart: SESSION_START_SUB,
            SessionEnd: SESSION_END_SUB,
            SessionWarning: SESSION_WARNING_SUB
        }
    }

    /**
    * Helper method to manage subscriptions
    * @method subscribeToSessionManagementEvent
    * @param {String} passedSubscribeType subscription type to use
    * @param {Object} passedScope scope to use for notification
    * @param {Function} passedCallBack function to call 
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function subscribeToSessionManagementEvent(passedSubscribeType, passedScope, passedCallBack) {
        var subscribeHandler = $rootScope.$on(passedSubscribeType, passedCallBack);
        passedScope.$on('$destroy', subscribeHandler);
    }

    /**
    * This method starts the session and notifies subscribers
    * @method startSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function startSession() {
        //check if session is already started and call end session and then start it 
        if (!sessionStarted) {
            sessionStarted = true;
            timeSetUp();
            sessionStartNotify();
        }

    }

    /**
    * This method ends the session and notifies subscribers
    * @method isSessionStarted
    * @returns {Boolean} true is session is started false if not
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function isSessionStarted() {
        return sessionStarted;
    }

    /**
    * Renews the session timers
    * @method renewSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function renewSession() {

        var deferred = $q.defer();

        if (sessionStarted) {
            authenticationFactory.refreshAuthentication().then(function (resp) {
                deferred.resolve(true);
            },
            function (resp) {
                deferred.reject(false);
            });
            timeTearDown();
            timeSetUp();
        }
        else {
            //session is not started so there is no session to renew
            deferred.reject(false);
        }

        return deferred.promise;
    }

    /**
    * This method ends the session and notifies subscribers
    * @method endSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function endSession() {
        //check if session has started if not then do nothing
        if (sessionStarted) {
            sessionStarted = false;
            sessionEndNotify();
            timeTearDown();
            authenticationFactory.clearAuthentication();
        }
    }

    /**
    * Method that returns the difference between the start time and the current time
    * @method timeLeftInSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function timeLeftInSession() {
        //return delta between passed time and time left
        var currentDate = new Date();
        return currentDate - timeStart;
    }

    /**
    * Helper method that sends notification that the session has started to subscribers
    * @method sessionStartNotify
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionStartNotify() {
        $rootScope.$emit(SESSION_START_SUB);
    }

    /**
    * Helper method that sends notification that the session has is entering warning stage to subscribers
    * @method sessionWarningNotify
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionWarningNotify() {
        $rootScope.$emit(SESSION_WARNING_SUB);
    }

    /**
    * Helper method that sends notification that the session has ended to subscribers
    * @method sessionEndNotify
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionEndNotify() {
        $rootScope.$emit(SESSION_END_SUB);
    }

    /**
    * Helper method sets up the timers and timeStart
    * @method timeSetUp
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function timeSetUp() {
        timeStart = new Date();
        warningTime = $timeout(sessionWarningNotify, TIME_WARNING_LENGTH);
        endTime = $timeout(endSession, TIME_END_LENGTH);
    }

    /**
    * Helper method tears down the timers and timeStart
    * @method timeSetUp
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function timeTearDown() {
        timeStart = 0;
        $timeout.cancel(warningTime);
        $timeout.cancel(endTime);
    }

    var service = {
        sessionManagementEvents: sessionManagementEvents,
        subscribeToSessionManagementEvent: subscribeToSessionManagementEvent,
        startSession: startSession,
        endSession: endSession,
        renewSession: renewSession,
        timeLeftInSession: timeLeftInSession,
        isSessionStarted: isSessionStarted
    };

    return service;

}

module.exports = sessionManagementFactory;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/session/sessionManagementFactory.js
// module id = 27
// module chunks = 0